"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleFilters = void 0;
const react_1 = __importDefault(require("react"));
const Filter_1 = require("../Filter");
const ExampleFilterList_1 = require("./ExampleFilterList");
const ExampleFilterRange_1 = require("./ExampleFilterRange");
const ExampleFilterSlider_1 = require("./ExampleFilterSlider");
const ExampleFilters = () => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h3", null, "Filters"),
        react_1.default.createElement(Filter_1.Filters, { renderFilterList: ExampleFilterList_1.ExampleFilterList, renderFilterRange: ExampleFilterRange_1.ExampleFilterRange, renderFilterSlider: ExampleFilterSlider_1.ExampleFilterSlider })));
};
exports.ExampleFilters = ExampleFilters;
//# sourceMappingURL=ExampleFilters.js.map